import { SxProps, Theme } from "@mui/material";

// Estilo de los ítems del menú contextual
export const menuItemSx: SxProps<Theme> = {
  borderRadius: 3,
  fontFamily: "Montserrat",
  transition: "background-color .15s ease, color .15s ease, padding-left .15s ease",
  "&:hover": {
    bgcolor: "#25485A",
    color: "#F8AD0C",
    pl: 2.5,
  },
  "&.Mui-focusVisible": {
    bgcolor: "#25485A",
    color: "#F8AD0C",
  },
  position: "relative",
  "&:hover::before, &.Mui-focusVisible::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 6,
    bottom: 6,
    width: 4,
    borderRadius: 2,
    backgroundColor: "#F8AD0C",
  },
};

// Estilo del Paper del Popover
export const menuPaperProps = {
  elevation: 0,
  sx: {
    bgcolor: "#1D3D4D",
    borderRadius: 5,
    color: "#FFF",
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
  },
};

// Estilo del campo de texto (TextField)
export const textFieldSx: SxProps<Theme> = {
  mt: 0.5,
  mb: 1,
  "& .MuiInputBase-root": {
    bgcolor: "#0F2A36",
    color: "#FFF",
    fontFamily: "Montserrat",
    borderRadius: 3,
    px: 1,
  },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#F8AD0C",
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#9BB6C3",
    opacity: 1,
    fontFamily: "Montserrat",
  },
};
